import { call, put, select, takeLatest } from 'redux-saga/effects'
import { PatientAllergiesConstants } from '../store/patientAllergies.constants'
import { getPatientAllergiesSelector } from '../selectors'
import { IPatientAllergiesState } from '../store/patientAllergies.types'
import { getPcrIdSelector } from '../../home/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IPcr } from '../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../user/selectors'
import { setSavePatientAllergiesResponse } from '../store/patientAllergies.actions'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { setHasPatient } from '../../patientInformation/store/patientInformation.actions'

export function* saveAllergies() {
  const patientAllergies: IPatientAllergiesState = yield select(getPatientAllergiesSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    const pcrDocUpdated: IPcr = {
      ...pcrDoc,
      patient: {
        ...pcrDoc.patient,
        patientAllergies,
      },
    }
    try {
      yield put(setHasPatient(true))
      const response: string = yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
      yield put(setSavePatientAllergiesResponse(response))
    } catch (e) {
      yield put(throwPcrException(`savePatientAllergies() error: ${e}`))
    }
  } else {
    // todo: add to audit log
  }
}
export function* saveAllergiesSaga() {
  yield takeLatest([PatientAllergiesConstants.SAVE_ALLERGIES], performWithMutexHOG, saveAllergies)
}
